<template>
  <div class="checkout">
    <v-layout row>
    </v-layout>
  </div>
</template>

<script>
  import api from '@/api/gungho'
  import Events from '@/api/events'

  export default {
    metaInfo: {
      title: 'Checkout'
    },

    data () {
      return {
        valid: true,
        step: 0,
        states: [],
        countries: [],
        card: {
          name: '',
          number: '',
          expiration: '',
          security: ''
        },
        shippingMethods: false
      }
    },

    computed: {
      agree () {
        return this.$store.state.agree
      }
    },

    methods: {
      loadShippingMethods () {
        if (!this.validCart || !this.validAddress) return false
        this.shippingMethods = false
        api.shippingMethods(this.$store.state.cart.id).then(data => {
          console.log('Load Shipping Methods')
          this.shippingMethods = data.shipping_methods
        }).catch(error => {
          console.log(error)
        })
      },

      saveCartAddresses () {
        if (!this.validAddress) {
          Events.$emit('error', 'Please enter your shipping and/or billing information')
          return false
        }
        this.step = 2
        Events.$emit('toast', 'Saved Shipping / Billing Info')
        this.saveCart()
      },

      saveShippingMethod () {
        if (!this.validShipping) {
          Events.$emit('error', 'Please select a shipping method')
          return false
        }
        this.step = 3
        Events.$emit('toast', 'Saved Shipping Method')
        this.saveCart()
      },

      saveAgreement () {
        if (!this.agree) {
          Events.$emit('error', 'Please check the "I have reviewed my order"... box')
          return false
        }
        this.step = 4
        return true
      },

      makePayment () {
        var data = new FormData()
        data.append('credit_card[name]', this.card.name)
        data.append('credit_card[number]', this.card.number)
        data.append('credit_card[expiration]', this.card.expiration)
        data.append('credit_card[ccv]', this.card.security)

        api.payment(this.$store.state.cart.id, data).then(data => {
          if (data.charged === true) {
            Events.$emit('toast', data.response_text)
            api.createOrder(this.$store.state.cart.id, data).then(data => {
              this.$router.push('/orders/' + data)
            }).catch(error => {
              console.log('Error', error)
            })
          } else {
            Events.$emit('error', data.response_text)
            console.log('Payment Error Response: ', data.response_text)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },

    beforeMount () {
      this.$store.dispatch('loadCart')
      this.loadShippingMethods()
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?0fe9a1ad